import { Component, Input } from '@angular/core';
import { IconService } from '../../../../services/icon.service';

@Component({
  selector: 'app-portal-promoted-feature',
  templateUrl: './portal-promoted-feature.component.html',
  styleUrls: ['./portal-promoted-feature.component.scss']
})
export class PortalPromotedFeatureComponent {
  constructor(private iconService: IconService){}
  @Input({ required: true }) title!: string;
  icon: string = "";
  @Input() set iconUrl(value: string){
    this.iconService.addIconToRegistry({
      key: value,
      path: value
    });
    this.icon = value;
  }
}
